<template>
  <div></div>
</template>
<script>
export default {
  inject: ['google', 'map'],
  props: {
    position: {
      type: Object,
    },
  },
  data() {
    return {
      marker: null,
    };
  },
  mounted() {
    const { Marker } = this.google.maps;
    this.marker = new Marker({
      position: this.position,
      map: this.map,
      title: 'Map',
    });
  },
};
</script>
